export default "__VITE_ASSET__B$xH5hBO__"